import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from '../i18n/LanguageContext';
const MusicPage = ({ API, isDarkMode, showNotification, currentUser, userToken, hasPaidPlan, setCurrentView, setInitialProfileTab }) => {
  const { t } = useTranslation();

  // Theme: light mode = purple (current design), dark mode = standard dark grays
  const theme = React.useMemo(() => isDarkMode ? {
    pageBg: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
    sidebarBg: '#1e293b',
    panelBg: '#1e293b',
    cardBg: '#1e293b',
    cardInfoBg: '#1e293b',
    inputBg: '#334155',
    inputBorder: 'rgba(255,255,255,0.1)',
    subtleBorder: 'rgba(255,255,255,0.08)',
    pillBg: '#334155',
    pillActiveBg: 'rgba(139,92,246,0.3)',
    accentBg: 'rgba(139,92,246,0.7)',
    overlayBg: 'rgba(15,23,42,0.6)',
    logoBg: 'rgba(139,92,246,0.2)',
    logoShadow: '0 4px 15px rgba(139,92,246,0.15)',
    navActiveBg: 'rgba(139,92,246,0.2)',
    navActiveInset: 'inset 0 1px 0 rgba(255,255,255,0.05)',
    playerBg: '#1e293b',
    playerBorder: '1px solid rgba(255,255,255,0.1)',
    playerShadow: '0 -4px 20px rgba(0,0,0,0.3)',
    imagePlaceholder: 'linear-gradient(135deg, #334155, #475569)',
    imagePlaceholderStrong: 'linear-gradient(135deg, #475569, #64748b)',
    imageBorder: '2px solid rgba(139,92,246,0.3)',
    imageShadow: '0 4px 15px rgba(0,0,0,0.3)',
    announcementBg: '#334155',
    progressTrack: 'rgba(255,255,255,0.1)',
    progressFill: 'rgba(139,92,246,0.7)',
    emptyIconBg: '#334155',
    playAllBg: 'rgba(139,92,246,0.6)',
    playAllShadow: '0 4px 15px rgba(139,92,246,0.2)',
    nowPlayingBadgeBg: 'rgba(139,92,246,0.7)',
    currentSongBorder: '2px solid rgba(139,92,246,0.5)',
    currentSongShadow: '0 8px 32px rgba(139,92,246,0.15)',
    defaultSongBorder: '1px solid rgba(255,255,255,0.08)',
    defaultSongShadow: '0 4px 15px rgba(0,0,0,0.2)',
    modalBg: '#1e293b',
    modalBorder: '1px solid rgba(255,255,255,0.1)',
    modalShadow: '0 20px 60px rgba(0,0,0,0.5)',
    buttonSecondaryBg: '#334155',
    floatingActiveBg: 'rgba(139,92,246,0.7)',
    floatingInactiveBg: '#1e293b',
    playlistSelectedBg: 'rgba(139,92,246,0.15)',
    playlistItemBg: '#334155',
    playingIndicatorBg: 'rgba(139,92,246,0.08)',
  } : {
    pageBg: 'linear-gradient(135deg, #0a0e27 0%, #1a1040 40%, #0d1333 70%, #0a0e27 100%)',
    sidebarBg: 'rgba(16,21,61,0.5)',
    panelBg: 'rgba(16,21,61,0.3)',
    cardBg: 'rgba(16,21,61,0.5)',
    cardInfoBg: 'rgba(16,21,61,0.7)',
    inputBg: 'rgba(106,109,155,0.3)',
    inputBorder: 'rgba(255,255,255,0.12)',
    subtleBorder: 'rgba(255,255,255,0.08)',
    pillBg: 'rgba(106,109,155,0.25)',
    pillActiveBg: 'rgba(200,187,255,0.4)',
    accentBg: 'rgba(200,187,255,0.6)',
    overlayBg: 'rgba(16,21,61,0.5)',
    logoBg: 'rgba(200,187,255,0.3)',
    logoShadow: '0 4px 15px rgba(200,187,255,0.2)',
    navActiveBg: 'rgba(106,109,155,0.5)',
    navActiveInset: 'inset 0 1px 0 rgba(255,255,255,0.1)',
    playerBg: 'rgba(188,184,198,0.2)',
    playerBorder: '1px solid rgba(255,255,255,0.15)',
    playerShadow: 'inset 2px -2px 6px rgba(214,214,214,0.1), inset -3px 3px 3px rgba(255,255,255,0.15), 0 10px 40px rgba(0,0,0,0.3)',
    imagePlaceholder: 'linear-gradient(135deg, rgba(200,187,255,0.3), rgba(106,109,155,0.3))',
    imagePlaceholderStrong: 'linear-gradient(135deg, rgba(200,187,255,0.4), rgba(106,109,155,0.4))',
    imageBorder: '2px solid rgba(222,215,255,0.5)',
    imageShadow: '0 4px 15px rgba(200,187,255,0.3)',
    announcementBg: 'linear-gradient(90deg, rgba(200,187,255,0.25), rgba(160,140,230,0.2))',
    progressTrack: 'rgba(255,255,255,0.15)',
    progressFill: 'rgba(200,187,255,0.6)',
    emptyIconBg: 'rgba(106,109,155,0.3)',
    playAllBg: 'rgba(200,187,255,0.5)',
    playAllShadow: 'inset 0 1px 0 rgba(255,255,255,0.2), 0 4px 15px rgba(200,187,255,0.2)',
    nowPlayingBadgeBg: 'rgba(200,187,255,0.6)',
    currentSongBorder: '2px solid rgba(200,187,255,0.6)',
    currentSongShadow: '0 8px 32px rgba(200,187,255,0.2)',
    defaultSongBorder: '1px solid rgba(255,255,255,0.08)',
    defaultSongShadow: '0 4px 15px rgba(0,0,0,0.2)',
    modalBg: 'rgba(16,21,61,0.95)',
    modalBorder: '1px solid rgba(255,255,255,0.1)',
    modalShadow: '0 20px 60px rgba(0,0,0,0.5)',
    buttonSecondaryBg: 'rgba(106,109,155,0.4)',
    floatingActiveBg: 'rgba(200,187,255,0.6)',
    floatingInactiveBg: 'rgba(16,21,61,0.6)',
    playlistSelectedBg: 'rgba(200,187,255,0.2)',
    playlistItemBg: 'rgba(106,109,155,0.2)',
    playingIndicatorBg: 'linear-gradient(90deg, rgba(200,187,255,0.15), rgba(106,109,155,0.1))',
  }, [isDarkMode]);

  // Core state
  // App-shell caches: read synchronously so songs / categories / header chrome
  // render from frame 1 instead of the loading spinner on Ctrl+R.
  const _readMusicCache = (key) => {
    try { const c = localStorage.getItem(key); if (c) return JSON.parse(c); } catch {}
    return null;
  };
  const _cachedSongs = _readMusicCache('musicSongsCache');
  const _cachedMusicCategories = _readMusicCache('musicCategoriesCache');
  const _cachedMusicSettings = _readMusicCache('musicSettingsCache');

  const [songs, setSongs] = useState(_cachedSongs || []);
  const [categories, setCategories] = useState(_cachedMusicCategories || []);
  const [filteredSongs, setFilteredSongs] = useState(_cachedSongs || []);
  const [isLoading, setIsLoading] = useState(!_cachedSongs);
  const [musicSettings, setMusicSettings] = useState(_cachedMusicSettings || {
    headerTitle: 'Darija Music',
    headerSubtitle: 'Learn through music',
    headerLogoUrl: '',
    headerAnnouncement: ''
  });

  // Filters
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Description popup
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);

  // Player state
  const [currentSong, setCurrentSong] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentLyricIndex, setCurrentLyricIndex] = useState(-1);
  const [volume, setVolume] = useState(0.7);
  const [audioError, setAudioError] = useState(false);
  const [isShuffled, setIsShuffled] = useState(false);
  const [repeatMode, setRepeatMode] = useState('none'); // none, one, all

  // UI state - Mobile fullscreen player
  const [sidebarTab, setSidebarTab] = useState('browse'); // browse, playlists, favorites, recent
  const [showFullscreenPlayer, setShowFullscreenPlayer] = useState(false); // TikTok-style fullscreen on mobile
  const [showLyrics, setShowLyrics] = useState(true);
  const [lyricsFontSize, setLyricsFontSize] = useState('medium'); // small, medium, large

  // User data
  const [userPlaylists, setUserPlaylists] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [recentlyPlayed, setRecentlyPlayed] = useState([]);
  const [showCreatePlaylist, setShowCreatePlaylist] = useState(false);
  const [newPlaylistName, setNewPlaylistName] = useState('');
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [showAddToPlaylist, setShowAddToPlaylist] = useState(null);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [editPlaylistName, setEditPlaylistName] = useState('');
  const [deletePlaylistConfirm, setDeletePlaylistConfirm] = useState(null); // playlist to delete
  const [showMobilePlaylistMenu, setShowMobilePlaylistMenu] = useState(false);
  const [showMusicHelp, setShowMusicHelp] = useState(false);

  // Refs
  const audioRef = useRef(null);
  const lyricsContainerRef = useRef(null);
  const mobileLyricsContainerRef = useRef(null);
  const isLoadingAudio = useRef(false);
  const previousVolumeRef = useRef(0.7);

  // Load songs, categories, and settings on mount (parallel)
  useEffect(() => {
    loadUserData();
    Promise.all([loadSongs(), loadCategories(), loadMusicSettings()]);
  }, []);

  const loadMusicSettings = async () => {
    try {
      const response = await fetch(`${API}/music/settings`);
      if (response.ok) {
        const data = await response.json();
        setMusicSettings(prev => {
          const merged = { ...prev, ...data };
          try { localStorage.setItem('musicSettingsCache', JSON.stringify(merged)); } catch {}
          return merged;
        });
      }
    } catch (error) {
      console.error('Error loading music settings:', error);
    }
  };

  // Filter songs when search or category changes
  useEffect(() => {
    let filtered = songs;

    // Search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(s =>
        s.title?.toLowerCase().includes(query) ||
        s.artist?.toLowerCase().includes(query) ||
        s.description?.toLowerCase().includes(query)
      );
    }

    // Category filter
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(s => s.category === selectedCategory);
    }

    // Playlist filter
    if (selectedPlaylist) {
      const playlistSongIds = selectedPlaylist.songIds || [];
      filtered = filtered.filter(s => playlistSongIds.includes(s.id));
    }

    setFilteredSongs(filtered);
  }, [searchQuery, selectedCategory, songs, selectedPlaylist]);

  // Load user data (playlists, favorites, recently played)
  const loadUserData = async () => {
    // Load from localStorage. Wrap each parse so corrupted entries can't crash the page.
    const safeParse = (raw, fallback) => {
      if (!raw) return fallback;
      try { return JSON.parse(raw); } catch { return fallback; }
    };
    setFavorites(safeParse(localStorage.getItem('musicFavorites'), []));
    setRecentlyPlayed(safeParse(localStorage.getItem('musicRecentlyPlayed'), []));
    setUserPlaylists(safeParse(localStorage.getItem('musicPlaylists'), []));
  };

  // Save favorites
  const toggleFavorite = (songId) => {
    const newFavorites = favorites.includes(songId)
      ? favorites.filter(id => id !== songId)
      : [...favorites, songId];
    setFavorites(newFavorites);
    try { localStorage.setItem('musicFavorites', JSON.stringify(newFavorites)); } catch {}
    showNotification(favorites.includes(songId) ? t('music_removed_from_favorites') : t('added_to_favorites'), 'success');
  };

  // Add to recently played
  const addToRecentlyPlayed = (song) => {
    const newRecent = [song.id, ...recentlyPlayed.filter(id => id !== song.id)].slice(0, 20);
    setRecentlyPlayed(newRecent);
    try { localStorage.setItem('musicRecentlyPlayed', JSON.stringify(newRecent)); } catch {}
  };

  // Playlist functions
  const createPlaylist = () => {
    if (!newPlaylistName.trim()) return;
    const newPlaylist = {
      id: Date.now().toString(),
      name: newPlaylistName.trim(),
      songIds: [],
      createdAt: new Date().toISOString()
    };
    const updatedPlaylists = [...userPlaylists, newPlaylist];
    setUserPlaylists(updatedPlaylists);
    try { localStorage.setItem('musicPlaylists', JSON.stringify(updatedPlaylists)); } catch {}
    setNewPlaylistName('');
    setShowCreatePlaylist(false);
    showNotification(t('music_playlist_created'), 'success');
  };

  const addToPlaylist = (playlistId, songId) => {
    const updatedPlaylists = userPlaylists.map(p => {
      if (p.id === playlistId && !p.songIds.includes(songId)) {
        return { ...p, songIds: [...p.songIds, songId] };
      }
      return p;
    });
    setUserPlaylists(updatedPlaylists);
    try { localStorage.setItem('musicPlaylists', JSON.stringify(updatedPlaylists)); } catch {}
    setShowAddToPlaylist(null);
    showNotification(t('music_added_to_playlist'), 'success');
  };

  const removeFromPlaylist = (playlistId, songId) => {
    const updatedPlaylists = userPlaylists.map(p => {
      if (p.id === playlistId) {
        return { ...p, songIds: p.songIds.filter(id => id !== songId) };
      }
      return p;
    });
    setUserPlaylists(updatedPlaylists);
    try { localStorage.setItem('musicPlaylists', JSON.stringify(updatedPlaylists)); } catch {}
    // Sync selectedPlaylist so the song list re-renders immediately without a tab switch
    if (selectedPlaylist?.id === playlistId) {
      const updated = updatedPlaylists.find(p => p.id === playlistId);
      if (updated) setSelectedPlaylist(updated);
    }
  };

  const deletePlaylist = (playlistId) => {
    const updatedPlaylists = userPlaylists.filter(p => p.id !== playlistId);
    setUserPlaylists(updatedPlaylists);
    try { localStorage.setItem('musicPlaylists', JSON.stringify(updatedPlaylists)); } catch {}
    if (selectedPlaylist?.id === playlistId) setSelectedPlaylist(null);
    showNotification(t('music_playlist_deleted'), 'success');
  };

  const renamePlaylist = (playlistId, newName) => {
    if (!newName.trim()) return;
    const updatedPlaylists = userPlaylists.map(p => {
      if (p.id === playlistId) {
        return { ...p, name: newName.trim() };
      }
      return p;
    });
    setUserPlaylists(updatedPlaylists);
    try { localStorage.setItem('musicPlaylists', JSON.stringify(updatedPlaylists)); } catch {}
    // Update selectedPlaylist if it's the one being renamed
    if (selectedPlaylist?.id === playlistId) {
      setSelectedPlaylist({ ...selectedPlaylist, name: newName.trim() });
    }
    setEditingPlaylist(null);
    setEditPlaylistName('');
    showNotification(t('music_playlist_renamed'), 'success');
  };

  const playAllInPlaylist = (playlist) => {
    if (!playlist || !playlist.songIds || playlist.songIds.length === 0) {
      showNotification(t('music_playlist_empty'), 'error');
      return;
    }
    // Get the first song in the playlist
    const firstSongId = playlist.songIds[0];
    const firstSong = songs.find(s => s.id === firstSongId);
    if (firstSong) {
      playSong(firstSong);
      showNotification(`Playing: ${playlist.name}`, 'success');
    }
  };

  // Update current lyric based on time
  useEffect(() => {
    if (!currentSong || !currentSong.lyrics) return;

    const lyrics = parseLyrics(currentSong.lyrics);

    // Check if lyrics have timestamps (at least one line with time >= 0)
    const hasTimestamps = lyrics.some(line => line.time >= 0);
    if (!hasTimestamps) return;

    let newIndex = -1;

    for (let i = 0; i < lyrics.length; i++) {
      // Only consider lines with valid timestamps
      if (lyrics[i].time >= 0 && currentTime >= lyrics[i].time) {
        newIndex = i;
      } else if (lyrics[i].time >= 0) {
        break;
      }
    }

    if (newIndex !== currentLyricIndex) {
      setCurrentLyricIndex(newIndex);
      console.log('Lyric index:', newIndex, 'Time:', currentTime);
    }
  }, [currentTime, currentSong, currentLyricIndex]);

  // Auto-scroll lyrics when index changes (both desktop and mobile)
  useEffect(() => {
    if (currentLyricIndex >= 0) {
      // Desktop lyrics panel
      if (lyricsContainerRef.current) {
        const lyricElements = lyricsContainerRef.current.querySelectorAll('.lyric-line');
        if (lyricElements[currentLyricIndex]) {
          lyricElements[currentLyricIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      // Mobile fullscreen lyrics
      if (mobileLyricsContainerRef.current) {
        const lyricElements = mobileLyricsContainerRef.current.querySelectorAll('.lyric-line');
        if (lyricElements[currentLyricIndex]) {
          lyricElements[currentLyricIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [currentLyricIndex]);

  // Convert Dropbox URL to streamable link for audio
  const getDirectAudioUrl = (url) => {
    if (!url) return '';
    let directUrl = url;

    // Handle Dropbox sharing links
    if (directUrl.includes('dropbox.com')) {
      // Replace www.dropbox.com with dl.dropboxusercontent.com
      directUrl = directUrl.replace('www.dropbox.com', 'dl.dropboxusercontent.com');

      // Change dl=0 or dl=1 to raw=1 (preserves rlkey and other params)
      directUrl = directUrl.replace('&dl=0', '&raw=1');
      directUrl = directUrl.replace('&dl=1', '&raw=1');
      directUrl = directUrl.replace('?dl=0', '?raw=1');
      directUrl = directUrl.replace('?dl=1', '?raw=1');

      // If no raw=1 exists, add it
      if (!directUrl.includes('raw=1')) {
        directUrl += (directUrl.includes('?') ? '&' : '?') + 'raw=1';
      }
    }

    console.log('Audio URL:', directUrl);
    return directUrl;
  };

  // Convert Dropbox image URL to raw format
  const getDirectImageUrl = (url) => {
    if (!url) return '';
    let directUrl = url;
    // Replace www.dropbox.com with dl.dropboxusercontent.com
    if (directUrl.includes('www.dropbox.com')) {
      directUrl = directUrl.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
    }
    // Change dl=0 to raw=1 for images
    if (directUrl.includes('dl=0')) {
      directUrl = directUrl.replace('dl=0', 'raw=1');
    }
    // Add raw=1 if not present for images
    if (!directUrl.includes('raw=1') && directUrl.includes('dropbox')) {
      directUrl += (directUrl.includes('?') ? '&' : '?') + 'raw=1';
    }
    return directUrl;
  };

  const loadSongs = async () => {
    try {
      const response = await fetch(`${API}/music/songs`, {
        headers: userToken ? { 'Authorization': `Bearer ${userToken}` } : {}
      });
      if (response.ok) {
        const data = await response.json();
        const list = data.songs || [];
        setSongs(list);
        setFilteredSongs(list);
        try { localStorage.setItem('musicSongsCache', JSON.stringify(list)); } catch {}
      }
    } catch (error) {
      console.error('Error loading songs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      const response = await fetch(`${API}/music/categories`);
      if (response.ok) {
        const data = await response.json();
        const cats = data.categories || [];
        setCategories(cats);
        try { localStorage.setItem('musicCategoriesCache', JSON.stringify(cats)); } catch {}
      }
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  // Parse timestamped lyrics [MM:SS]Text or [MM:SS.ms]Text
  const parseLyrics = (lyricsText) => {
    if (!lyricsText) return [];
    const lines = lyricsText.split('\n');
    const parsed = [];

    for (const line of lines) {
      // Match [MM:SS] or [MM:SS.ms] or [M:SS] formats
      const match = line.match(/\[(\d{1,2}):(\d{2})(?:\.\d+)?\](.*)/);
      if (match) {
        const minutes = parseInt(match[1]);
        const seconds = parseInt(match[2]);
        const text = match[3].trim();
        if (text) {
          parsed.push({
            time: minutes * 60 + seconds,
            text: text
          });
        }
      } else if (line.trim()) {
        // Non-timestamped line, add without time
        parsed.push({ time: -1, text: line.trim() });
      }
    }

    console.log('Parsed lyrics:', parsed);
    return parsed;
  };

  const playSong = (song, openFullscreen = false) => {
    setAudioError(false);
    const isMobile = window.innerWidth < 768;

    if (currentSong?.id === song.id) {
      // Toggle play/pause
      if (isPlaying) {
        audioRef.current?.pause();
        setIsPlaying(false);
      } else {
        audioRef.current?.play().catch(() => setAudioError(true));
        setIsPlaying(true);
      }
      // Open fullscreen on mobile when tapping current song
      if (isMobile || openFullscreen) {
        setShowFullscreenPlayer(true);
      }
    } else {
      // Play new song
      setCurrentSong(song);
      setCurrentTime(0);
      setCurrentLyricIndex(-1);
      setIsPlaying(true);
      addToRecentlyPlayed(song);
      // Open fullscreen player on mobile
      if (isMobile || openFullscreen) {
        setShowFullscreenPlayer(true);
      }
    }
  };

  // Effect to play audio when currentSong changes
  useEffect(() => {
    if (currentSong && audioRef.current) {
      // Flag to prevent onPause from resetting isPlaying during load
      isLoadingAudio.current = true;
      audioRef.current.load();
      if (isPlaying) {
        const playAudio = () => {
          isLoadingAudio.current = false;
          const playPromise = audioRef.current?.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log('Autoplay prevented:', error);
              setAudioError(true);
              setIsPlaying(false);
            });
          }
        };
        // Wait for audio to be ready
        if (audioRef.current.readyState >= 2) {
          playAudio();
        } else {
          audioRef.current.addEventListener('canplay', playAudio, { once: true });
        }
      } else {
        isLoadingAudio.current = false;
      }
    }
  }, [currentSong]);

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
      audioRef.current.volume = volume;
    }
  };

  const handleSeek = (e) => {
    const rect = e.target.getBoundingClientRect();
    const seekTime = ((e.clientX - rect.left) / rect.width) * duration;
    if (audioRef.current && !isNaN(seekTime)) {
      audioRef.current.currentTime = seekTime;
      setCurrentTime(seekTime);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  const handleSongEnd = () => {
    // Repeat one mode
    if (repeatMode === 'one') {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play();
      }
      return;
    }

    const currentIndex = filteredSongs.findIndex(s => s.id === currentSong?.id);

    // Shuffle mode
    if (isShuffled) {
      const availableSongs = filteredSongs.filter(s => s.id !== currentSong?.id);
      if (availableSongs.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableSongs.length);
        playSong(availableSongs[randomIndex]);
      }
      return;
    }

    // Normal or repeat all mode
    if (currentIndex < filteredSongs.length - 1) {
      playSong(filteredSongs[currentIndex + 1]);
    } else if (repeatMode === 'all' && filteredSongs.length > 0) {
      playSong(filteredSongs[0]);
    } else {
      setIsPlaying(false);
      setCurrentTime(0);
    }
  };

  const handleAudioError = () => {
    setAudioError(true);
    setIsPlaying(false);
  };

  const playNext = () => {
    const currentIndex = filteredSongs.findIndex(s => s.id === currentSong?.id);
    if (currentIndex < filteredSongs.length - 1) {
      playSong(filteredSongs[currentIndex + 1]);
    }
  };

  const playPrevious = () => {
    const currentIndex = filteredSongs.findIndex(s => s.id === currentSong?.id);
    if (currentIndex > 0) {
      playSong(filteredSongs[currentIndex - 1]);
    }
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Lyrics font size classes
  const lyricsFontClasses = {
    small: { active: 'text-lg md:text-xl', inactive: 'text-sm md:text-base' },
    medium: { active: 'text-2xl md:text-3xl', inactive: 'text-lg md:text-xl' },
    large: { active: 'text-3xl md:text-4xl', inactive: 'text-xl md:text-2xl' }
  };

  // Get songs for sidebar view
  const getSidebarSongs = () => {
    if (sidebarTab === 'favorites') {
      return songs.filter(s => favorites.includes(s.id));
    }
    if (sidebarTab === 'recent') {
      return recentlyPlayed.map(id => songs.find(s => s.id === id)).filter(Boolean);
    }
    return filteredSongs;
  };

  // Calculate progress percentage for song card
  const getSongProgress = (songId) => {
    if (currentSong?.id === songId && duration > 0) {
      return (currentTime / duration) * 100;
    }
    return 0;
  };

  if (isLoading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center animate-pulse">
            <span className="text-3xl">🎵</span>
          </div>
          <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>{t('music_loading')}</p>
        </div>
      </div>
    );
  }

  // Get display songs based on sidebar tab
  const getDisplaySongs = () => {
    if (sidebarTab === 'favorites') {
      return songs.filter(s => favorites.includes(s.id));
    }
    if (sidebarTab === 'recent') {
      return recentlyPlayed.map(id => songs.find(s => s.id === id)).filter(Boolean);
    }
    if (selectedPlaylist) {
      return songs.filter(s => selectedPlaylist.songIds?.includes(s.id));
    }
    return filteredSongs;
  };

  const displaySongs = getDisplaySongs();

  // Parse lyrics for display
  const parsedLyrics = currentSong?.lyrics ? parseLyrics(currentSong.lyrics) : [];

  const showProGlass = !!musicSettings.isProOnly && !hasPaidPlan;

  return (
    <div className="min-h-screen relative" style={{ background: theme.pageBg }}>
      {/* CD Animation Keyframes - always in DOM for both mobile and desktop */}
      <style>{`
        @keyframes cd-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes cd-float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-8px); } }
        @keyframes cd-ring-expand { 0% { transform: scale(0.8); opacity: 0.6; } 100% { transform: scale(2); opacity: 0; } }
        @keyframes cd-glow-pulse { 0%, 100% { opacity: 0.3; transform: scale(1); } 50% { opacity: 0.6; transform: scale(1.1); } }
        @keyframes cd-flash-orbit { 0% { transform: rotate(0deg) translateX(110px) rotate(0deg); opacity: 0.8; } 50% { opacity: 0.3; } 100% { transform: rotate(360deg) translateX(110px) rotate(-360deg); opacity: 0.8; } }
        @keyframes cd-flash-orbit2 { 0% { transform: rotate(180deg) translateX(105px) rotate(-180deg); opacity: 0.6; } 50% { opacity: 0.9; } 100% { transform: rotate(540deg) translateX(105px) rotate(-540deg); opacity: 0.6; } }
        @keyframes cd-sparkle { 0%, 100% { opacity: 0; transform: scale(0); } 50% { opacity: 1; transform: scale(1); } }
      `}</style>
      {/* Audio Element - Dropbox audio */}
      {currentSong && currentSong.audioUrl && (
        <audio
          ref={audioRef}
          src={getDirectAudioUrl(currentSong.audioUrl)}
          onTimeUpdate={handleTimeUpdate}
          onLoadedMetadata={handleLoadedMetadata}
          onEnded={handleSongEnd}
          onPlay={() => { isLoadingAudio.current = false; setIsPlaying(true); }}
          onPause={() => { if (!isLoadingAudio.current) setIsPlaying(false); }}
          onError={(e) => { console.log('Audio error:', e.target.error); handleAudioError(); }}
          onCanPlay={() => console.log('Audio ready to play:', currentSong.title)}
          preload="auto"
        />
      )}

      {/* ==================== MOBILE FULLSCREEN PLAYER (TikTok-style) ==================== */}
      {showFullscreenPlayer && currentSong && (
        <div className="md:hidden fixed inset-0 z-50 flex flex-col" style={{ background: 'linear-gradient(180deg, #0a0e27 0%, #1a1040 50%, #0a0e27 100%)' }}>
          {/* Top Bar - Song Info & Back */}
          <div className="flex items-center justify-between p-3" style={{ background: 'rgba(16,21,61,0.4)' }}>
            <button
              onClick={() => setShowFullscreenPlayer(false)}
              className="flex items-center gap-1 px-3 py-2 rounded-full text-white"
              style={{ background: 'rgba(106,109,155,0.4)' }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
              <span className="text-sm font-medium">{t('music_back')}</span>
            </button>
            <div className="text-center flex-1 px-4">
              <p className="text-white font-semibold truncate">{currentSong.title}</p>
              <p className="text-gray-400 text-sm truncate">{currentSong.artist || t('music_unknown_artist')}</p>
            </div>
            {/* Info Button - Shows description */}
            {currentSong.description ? (
              <button
                onClick={() => setShowDescriptionPopup(true)}
                className="flex items-center gap-1 px-3 py-2 rounded-full bg-blue-600/30 text-blue-300"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
            ) : (
              <div className="w-12"></div>
            )}
          </div>

          {/* Album Art - Small centered */}
          <div className="flex justify-center py-4">
            <div className="w-32 h-32 rounded-2xl overflow-hidden" style={{ background: 'linear-gradient(135deg, rgba(200,187,255,0.4), rgba(106,109,155,0.4))', border: '2px solid rgba(222,215,255,0.5)', boxShadow: '0 10px 40px rgba(200,187,255,0.3)' }}>
              {currentSong.imageUrl ? (
                <img src={getDirectImageUrl(currentSong.imageUrl)} alt="" className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-5xl">🎵</span>
                </div>
              )}
            </div>
          </div>

          {/* Lyrics Section - Main content area, scrolling */}
          <div
            ref={mobileLyricsContainerRef}
            className="flex-1 overflow-y-auto px-6 py-4"
          >
            {parsedLyrics.length > 0 ? (
              <div className="space-y-4 text-center py-[30vh]">
                {parsedLyrics.map((line, index) => (
                  <p
                    key={index}
                    className={`lyric-line transition-all duration-300 ${
                      index === currentLyricIndex
                        ? 'text-white text-2xl font-bold scale-105'
                        : index < currentLyricIndex
                          ? 'text-gray-500 text-lg'
                          : 'text-gray-400 text-lg'
                    }`}
                  >
                    {line.text}
                  </p>
                ))}
              </div>
            ) : (
              <div className="h-full flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
                {/* Expanding pulse rings that ripple outward */}
                {isPlaying && (
                  <>
                    <div className="absolute rounded-full border-2 border-purple-500/40" style={{ width: 190, height: 190, animation: 'cd-ring-expand 2s ease-out infinite' }} />
                    <div className="absolute rounded-full border-2 border-pink-500/30" style={{ width: 190, height: 190, animation: 'cd-ring-expand 2s ease-out infinite 0.7s' }} />
                    <div className="absolute rounded-full border border-cyan-400/20" style={{ width: 190, height: 190, animation: 'cd-ring-expand 2s ease-out infinite 1.4s' }} />
                  </>
                )}

                {/* CD Container with float effect */}
                <div className="relative" style={{ width: 180, height: 180, animation: isPlaying ? 'cd-float 3s ease-in-out infinite' : 'none' }}>
                  {/* Pulsing glow behind CD */}
                  {isPlaying && (
                    <>
                      <div className="absolute rounded-full blur-3xl" style={{ inset: -30, background: 'radial-gradient(circle, rgba(168,85,247,0.5) 0%, rgba(236,72,153,0.3) 40%, transparent 70%)', animation: 'cd-glow-pulse 2s ease-in-out infinite' }} />
                      <div className="absolute rounded-full blur-2xl" style={{ inset: -20, background: 'radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 60%)', animation: 'cd-glow-pulse 2.5s ease-in-out infinite 0.5s' }} />
                    </>
                  )}

                  {/* Orbiting light dots */}
                  {isPlaying && (
                    <>
                      <div className="absolute inset-0 flex items-center justify-center" style={{ animation: 'none' }}>
                        <div className="w-3 h-3 rounded-full bg-purple-400 blur-[2px]" style={{ animation: 'cd-flash-orbit 3s linear infinite', position: 'absolute' }} />
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-2.5 h-2.5 rounded-full bg-pink-400 blur-[2px]" style={{ animation: 'cd-flash-orbit2 4s linear infinite', position: 'absolute' }} />
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-cyan-400 blur-[1px]" style={{ animation: 'cd-flash-orbit 5s linear infinite reverse', position: 'absolute' }} />
                      </div>
                    </>
                  )}

                  {/* Sparkle dots around CD */}
                  {isPlaying && [0,1,2,3,4,5].map(i => (
                    <div key={i} className="absolute w-1.5 h-1.5 rounded-full bg-white"
                      style={{
                        top: `${50 + 58 * Math.sin((i / 6) * Math.PI * 2)}%`,
                        left: `${50 + 58 * Math.cos((i / 6) * Math.PI * 2)}%`,
                        animation: `cd-sparkle ${1.5 + i * 0.3}s ease-in-out infinite ${i * 0.4}s`,
                      }} />
                  ))}

                  {/* CD disc */}
                  <div className="w-full h-full rounded-full relative overflow-hidden shadow-2xl"
                    style={{
                      animation: isPlaying ? 'cd-spin 3s linear infinite' : 'none',
                      background: 'conic-gradient(from 0deg, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e)',
                      boxShadow: isPlaying ? '0 0 40px rgba(168,85,247,0.4), 0 0 80px rgba(236,72,153,0.2), 0 0 120px rgba(59,130,246,0.1)' : '0 8px 32px rgba(0,0,0,0.4)',
                    }}>
                    <div className="absolute inset-0 rounded-full"
                      style={{ background: 'conic-gradient(from 45deg, transparent 0%, rgba(255,255,255,0.06) 10%, transparent 20%, rgba(255,255,255,0.04) 30%, transparent 40%, rgba(255,255,255,0.08) 50%, transparent 60%, rgba(255,255,255,0.03) 70%, transparent 80%, rgba(255,255,255,0.05) 90%, transparent 100%)' }} />
                    <div className="absolute inset-[25%] rounded-full"
                      style={{ background: 'conic-gradient(from 0deg, rgba(168,85,247,0.15), rgba(59,130,246,0.15), rgba(16,185,129,0.15), rgba(245,158,11,0.15), rgba(236,72,153,0.15), rgba(168,85,247,0.15))', opacity: isPlaying ? 0.8 : 0.3 }} />
                    <div className="absolute inset-[15%] rounded-full border border-white/[0.03]" />
                    <div className="absolute inset-[20%] rounded-full border border-white/[0.03]" />
                    <div className="absolute inset-[30%] rounded-full border border-white/[0.02]" />
                    <div className="absolute inset-[35%] rounded-full border border-white/[0.03]" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-purple-700 flex items-center justify-center"
                        style={{ boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.4)' }}>
                        <div className="w-4 h-4 rounded-full bg-gray-900" style={{ boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.6)' }} />
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-gray-200 text-lg font-bold relative tracking-wide mt-8">{isPlaying ? `♪ ${t('music_feeling_beat')} ♪` : `🎵 ${t('music_no_lyrics')}`}</p>
                <p className="text-gray-500 text-sm mt-1 relative">{isPlaying ? t('music_let_music_move') : t('music_press_play')}</p>
              </div>
            )}
          </div>

          {/* Bottom Controls - Thinner and moved up */}
          <div className="px-4 pt-2 pb-20" style={{ background: 'rgba(16,21,61,0.5)', backdropFilter: 'blur(10px)' }}>
            {/* Progress Bar */}
            <div className="mb-2">
              <div
                className="h-1 rounded-full overflow-hidden cursor-pointer"
                style={{ background: 'rgba(255,255,255,0.15)' }}
                onClick={handleSeek}
              >
                <div
                  className="h-full rounded-full transition-all"
                  style={{ background: 'rgba(200,187,255,0.6)', width: `${duration ? (currentTime / duration) * 100 : 0}%` }}
                />
              </div>
              <div className="flex justify-between text-[10px] text-gray-400 mt-0.5">
                <span>{formatTime(currentTime)}</span>
                <span>{formatTime(duration)}</span>
              </div>
            </div>

            {/* Control Buttons - Compact */}
            <div className="flex items-center justify-center gap-4">
              {/* Shuffle */}
              <button
                onClick={() => setIsShuffled(!isShuffled)}
                className={`p-1.5 ${isShuffled ? 'text-purple-400' : 'text-gray-400'}`}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"/>
                </svg>
              </button>

              {/* Previous */}
              <button onClick={playPrevious} className="p-1.5 text-white">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 6h2v12H6V6zm3.5 6l8.5 6V6l-8.5 6z"/>
                </svg>
              </button>

              {/* Play/Pause - Medium */}
              <button
                onClick={() => playSong(currentSong)}
                className="w-12 h-12 rounded-full flex items-center justify-center"
                style={{ background: 'rgba(200,187,255,0.6)', boxShadow: '0 4px 20px rgba(200,187,255,0.3)' }}
              >
                {isPlaying ? (
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                  </svg>
                ) : (
                  <svg className="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7L8 5z"/>
                  </svg>
                )}
              </button>

              {/* Next */}
              <button onClick={playNext} className="p-1.5 text-white">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
                </svg>
              </button>

              {/* Repeat */}
              <button
                onClick={() => setRepeatMode(repeatMode === 'none' ? 'all' : repeatMode === 'all' ? 'one' : 'none')}
                className={`p-1.5 ${repeatMode !== 'none' ? 'text-purple-400' : 'text-gray-400'}`}
              >
                {repeatMode === 'one' ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"/>
                  </svg>
                ) : (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/>
                  </svg>
                )}
              </button>
            </div>

            {/* Volume Control */}
            <div className="flex items-center justify-center gap-3 mt-3">
              <button
                onClick={() => {
                  if (volume > 0) {
                    previousVolumeRef.current = volume;
                    setVolume(0);
                    if (audioRef.current) audioRef.current.volume = 0;
                  } else {
                    const restored = previousVolumeRef.current || 0.7;
                    setVolume(restored);
                    if (audioRef.current) audioRef.current.volume = restored;
                  }
                }}
                className="p-1 text-gray-400 hover:text-white"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {volume === 0 ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                  ) : volume < 0.5 ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M15.536 8.464a5 5 0 010 7.072" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M15.536 8.464a5 5 0 010 7.072 M18.364 5.636a9 9 0 010 12.728" />
                  )}
                </svg>
              </button>
              <input
                type="range"
                min="0" max="1" step="0.01"
                value={volume}
                onChange={handleVolumeChange}
                className="w-24 h-1 rounded-full appearance-none cursor-pointer"
                style={{ background: `linear-gradient(to right, rgba(200,187,255,0.6) ${volume * 100}%, rgba(255,255,255,0.15) ${volume * 100}%)` }}
              />
            </div>
          </div>
        </div>
      )}

      {/* ==================== MAIN LAYOUT ==================== */}
      <div className={`flex flex-col md:flex-row min-h-screen md:h-screen md:overflow-hidden ${showFullscreenPlayer ? 'hidden md:flex' : ''}`}>
        {/* Desktop Sidebar */}
        <div className="hidden md:flex flex-col w-64 h-screen sticky top-0" style={{ background: theme.sidebarBg, backdropFilter: 'blur(10px)', borderRight: `1px solid ${theme.subtleBorder}` }}>
          {/* Logo */}
          <div className="p-6" style={{ borderBottom: `1px solid ${theme.subtleBorder}` }}>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center overflow-hidden" style={{ background: theme.logoBg, boxShadow: theme.logoShadow }}>
                {musicSettings.headerLogoUrl ? (
                  <img src={getDirectImageUrl(musicSettings.headerLogoUrl)} alt="" className="w-full h-full object-cover" />
                ) : (
                  <span className="text-2xl">🎵</span>
                )}
              </div>
              <div>
                <h1 className="text-white font-bold text-lg">{musicSettings.headerTitle || t('music_title')}</h1>
                <p className="text-gray-400 text-xs">{musicSettings.headerSubtitle || t('music_subtitle')}</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
            <button
              onClick={() => { setSidebarTab('browse'); setSelectedPlaylist(null); }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                sidebarTab === 'browse' && !selectedPlaylist
                  ? 'text-white'
                  : 'text-gray-400 hover:text-white'
              }`}
              style={sidebarTab === 'browse' && !selectedPlaylist ? { background: theme.navActiveBg, boxShadow: theme.navActiveInset } : { background: 'transparent' }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
              <span className="font-medium">{t('music_browse')}</span>
            </button>

            {/* Playlists Section */}
            <div className="mt-4 pt-4" style={{ borderTop: `1px solid ${theme.subtleBorder}` }}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-gray-500 text-xs uppercase tracking-wider">{t('music_playlists')}</span>
                <button
                  onClick={() => setShowCreatePlaylist(true)}
                  className="text-gray-400 hover:text-white"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
              </div>
              {userPlaylists.map(playlist => (
                <div key={playlist.id} className="group relative">
                  {editingPlaylist === playlist.id ? (
                    /* Edit Mode */
                    <div className="flex items-center gap-2 px-3 py-2">
                      <input
                        type="text"
                        value={editPlaylistName}
                        onChange={(e) => setEditPlaylistName(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && renamePlaylist(playlist.id, editPlaylistName)}
                        className="flex-1 px-2 py-1 bg-white/10 border border-white/20 rounded text-white text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
                        autoFocus
                      />
                      <button
                        onClick={() => renamePlaylist(playlist.id, editPlaylistName)}
                        className="p-1 text-green-400 hover:text-green-300"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </button>
                      <button
                        onClick={() => { setEditingPlaylist(null); setEditPlaylistName(''); }}
                        className="p-1 text-red-400 hover:text-red-300"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    /* Normal Mode */
                    <button
                      onClick={() => { setSelectedPlaylist(playlist); setSidebarTab('browse'); }}
                      className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left transition-all ${
                        selectedPlaylist?.id === playlist.id
                          ? 'text-white'
                          : 'text-gray-400 hover:text-white'
                      }`}
                      style={selectedPlaylist?.id === playlist.id ? { background: theme.navActiveBg } : {}}
                    >
                      <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                      </svg>
                      <span className="text-sm truncate flex-1">{playlist.name}</span>
                      <span className="text-xs opacity-60">{playlist.songIds?.length || 0}</span>
                    </button>
                  )}
                  {/* Hover Actions */}
                  {editingPlaylist !== playlist.id && (
                    <div className="absolute right-2 top-1/2 -translate-y-1/2 hidden group-hover:flex items-center gap-1 bg-gray-800 rounded-lg p-1">
                      {/* Play All */}
                      <button
                        onClick={(e) => { e.stopPropagation(); playAllInPlaylist(playlist); }}
                        className="p-1 text-green-400 hover:text-green-300"
                        title={t('play_all')}
                      >
                        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7L8 5z"/>
                        </svg>
                      </button>
                      {/* Edit Name */}
                      <button
                        onClick={(e) => { e.stopPropagation(); setEditingPlaylist(playlist.id); setEditPlaylistName(playlist.name); }}
                        className="p-1 text-blue-400 hover:text-blue-300"
                        title={t('rename')}
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                      </button>
                      {/* Delete */}
                      <button
                        onClick={(e) => { e.stopPropagation(); setDeletePlaylistConfirm(playlist); }}
                        className="p-1 text-red-400 hover:text-red-300"
                        title={t('morocco_delete')}
                      >
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </nav>

          {/* User Playlists Section */}
          <div className="p-4" style={{ borderTop: `1px solid ${theme.subtleBorder}` }}>
            <p className="text-gray-500 text-xs uppercase tracking-wider mb-2">{t('music_your_library')}</p>
            <p className="text-gray-400 text-sm">{songs.length} {t('music_songs_available')}</p>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Announcement Banner - Shows above search */}
          {musicSettings.headerAnnouncement && (
            <div className="px-4 md:px-6 py-3 backdrop-blur-sm" style={{ background: theme.announcementBg, borderBottom: `1px solid ${theme.subtleBorder}` }}>
              <div className="max-w-4xl mx-auto flex items-center justify-center gap-2">
                <span className="text-lg">📢</span>
                <p className="text-white text-sm md:text-base font-medium text-center">
                  {musicSettings.headerAnnouncement}
                </p>
              </div>
            </div>
          )}

          {/* Top Search Bar */}
          <div className="p-4 md:p-6" style={{ background: theme.panelBg, backdropFilter: 'blur(10px)', borderBottom: `1px solid ${theme.subtleBorder}` }}>
            <div className="max-w-4xl mx-auto">
              {/* Search Input */}
              <div className="relative mb-4">
                <svg className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder={t('music_search_placeholder')}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 rounded-2xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-transparent transition-all"
                  style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}` }}
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>

              {/* Category Pills */}
              <div className="flex flex-wrap items-center gap-2 overflow-x-auto pb-1">
                  <button
                    onClick={() => setSelectedCategory('all')}
                    className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all ${
                      selectedCategory === 'all'
                        ? 'text-white'
                        : 'text-gray-300 hover:text-white'
                    }`}
                    style={selectedCategory === 'all' ? { background: theme.pillActiveBg, boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.15)' } : { background: theme.pillBg }}
                  >
                    {t('all')}
                  </button>
                  {categories.filter(c => c.status === 1).map(cat => (
                    <button
                      key={cat.id}
                      onClick={() => setSelectedCategory(cat.id)}
                      className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all flex items-center gap-2 ${
                        selectedCategory === cat.id
                          ? 'text-white'
                          : 'text-gray-300 hover:text-white'
                      }`}
                      style={selectedCategory === cat.id ? {
                        background: `linear-gradient(135deg, ${cat.color || '#8B5CF6'}, ${cat.color ? cat.color + 'CC' : '#A855F7'})`,
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.15)'
                      } : { background: theme.pillBg }}
                    >
                      <span>{cat.icon || '🎵'}</span>
                      <span>{cat.name}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>

          {/* Song Cards Grid */}
          <div className="flex-1 overflow-y-auto p-4 md:p-6">
            {filteredSongs.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-64 text-center">
                <div className="w-20 h-20 rounded-full flex items-center justify-center mb-4" style={{ background: theme.emptyIconBg }}>
                  <span className="text-4xl">🎵</span>
                </div>
                <h3 className="text-white text-lg font-medium mb-2">{t('music_no_songs_found')}</h3>
                <p className="text-gray-400 text-sm">{t('music_adjust_filters')}</p>
              </div>
            ) : (
              <>
                {/* Section Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-start gap-3 min-w-0">
                    {/* Back-to-all-songs button — only when a playlist is selected */}
                    {selectedPlaylist && (
                      <button
                        onClick={() => setSelectedPlaylist(null)}
                        className="flex-shrink-0 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm flex items-center justify-center transition-colors mt-1"
                        aria-label="Back to all songs"
                        title={t('back_to_songs')}
                      >
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                    )}
                    <div className="min-w-0">
                      {/* Show "My Playlist" label when viewing a playlist */}
                      {selectedPlaylist && (
                        <p className="text-purple-400 text-xs font-medium uppercase tracking-wider mb-1">{t('music_my_playlist')}</p>
                      )}
                      <h2 className="text-white text-xl font-bold truncate">
                        {sidebarTab === 'favorites' ? t('music_your_favorites') :
                         sidebarTab === 'recent' ? t('music_recently_played') :
                         selectedPlaylist ? selectedPlaylist.name : t('music_all_songs')}
                      </h2>
                      <p className="text-gray-400 text-sm">{filteredSongs.length} {t('music_songs')}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => filteredSongs.length > 0 && playSong(filteredSongs[0])}
                    className="px-5 py-2.5 rounded-xl text-white font-medium text-sm flex items-center gap-2 hover:opacity-90 transition-all"
                    style={{ background: theme.playAllBg, boxShadow: theme.playAllShadow }}
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                    {t('music_play_all')}
                  </button>
                </div>

                {/* Game-Style Song Cards Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
                  {filteredSongs.map((song, index) => (
                    <div
                      key={song.id}
                      onClick={() => playSong(song)}
                      className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 ${
                        currentSong?.id === song.id ? '' : ''
                      }`}
                      style={{
                        background: theme.cardBg,
                        border: currentSong?.id === song.id ? theme.currentSongBorder : theme.defaultSongBorder,
                        boxShadow: currentSong?.id === song.id ? theme.currentSongShadow : theme.defaultSongShadow,
                      }}
                    >
                      {/* Song Image with Progress Ring */}
                      <div className="aspect-square relative" style={{ background: theme.imagePlaceholder }}>
                        {song.imageUrl ? (
                          <img src={getDirectImageUrl(song.imageUrl)} alt={song.title} className="w-full h-full object-cover" draggable={false} />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center">
                            <span className="text-5xl">🎵</span>
                          </div>
                        )}

                        {/* Progress Ring Overlay (when playing) */}
                        {currentSong?.id === song.id && (
                          <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 100 100">
                            <circle
                              cx="50" cy="50" r="48"
                              fill="none"
                              stroke="rgba(139, 92, 246, 0.3)"
                              strokeWidth="4"
                            />
                            <circle
                              cx="50" cy="50" r="48"
                              fill="none"
                              stroke="url(#progressGradient)"
                              strokeWidth="4"
                              strokeLinecap="round"
                              strokeDasharray={`${(currentTime / (duration || 1)) * 301.59} 301.59`}
                            />
                            <defs>
                              <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#8B5CF6" />
                                <stop offset="100%" stopColor="#EC4899" />
                              </linearGradient>
                            </defs>
                          </svg>
                        )}

                        {/* Play/Pause Overlay */}
                        <div className={`absolute inset-0 flex items-center justify-center transition-opacity ${
                          currentSong?.id === song.id ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                        }`} style={{ background: theme.overlayBg }}>
                          <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ background: theme.accentBg, backdropFilter: 'blur(8px)' }}>
                            {currentSong?.id === song.id && isPlaying ? (
                              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                              </svg>
                            ) : (
                              <svg className="w-6 h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8 5v14l11-7L8 5z"/>
                              </svg>
                            )}
                          </div>
                        </div>

                        {/* Now Playing Indicator */}
                        {currentSong?.id === song.id && isPlaying && (
                          <div className="absolute bottom-2 left-2 flex items-center gap-1 px-2 py-1 rounded-full backdrop-blur-sm" style={{ background: theme.nowPlayingBadgeBg }}>
                            <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
                            <span className="text-[10px] text-white font-medium">{t('music_playing')}</span>
                          </div>
                        )}

                        {/* Add/Remove Playlist Button */}
                        {selectedPlaylist ? (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              removeFromPlaylist(selectedPlaylist.id, song.id);
                              showNotification(t('removed_from_playlist'), 'success');
                            }}
                            className="absolute top-2 left-2 w-8 h-8 rounded-full bg-red-500/80 backdrop-blur-sm flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity hover:bg-red-600"
                          >
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        ) : (
                          <button
                            onClick={(e) => { e.stopPropagation(); setShowAddToPlaylist(song.id); }}
                            className="absolute top-2 left-2 w-8 h-8 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity"
                          >
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                          </button>
                        )}
                      </div>

                      {/* Song Info */}
                      <div className="p-3" style={{ background: theme.cardInfoBg, backdropFilter: 'blur(8px)' }}>
                        <h3 className={`font-semibold text-sm truncate ${currentSong?.id === song.id ? 'text-purple-400' : 'text-white'}`}>
                          {song.title}
                        </h3>
                        <p className="text-gray-400 text-xs truncate mt-0.5">{song.artist || t('music_unknown_artist')}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Desktop Lyrics Panel - Right Side */}
        {currentSong && showLyrics && (
          <div className="hidden md:flex flex-col w-80 lg:w-96 h-screen sticky top-0" style={{ background: theme.sidebarBg, backdropFilter: 'blur(10px)', borderLeft: `1px solid ${theme.subtleBorder}` }}>
            {/* Panel Header */}
            <div className="p-4 flex items-center justify-between" style={{ borderBottom: `1px solid ${theme.subtleBorder}` }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl overflow-hidden" style={{ background: theme.imagePlaceholderStrong }}>
                  {currentSong.imageUrl ? (
                    <img src={getDirectImageUrl(currentSong.imageUrl)} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <span className="text-lg">🎵</span>
                    </div>
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-white font-semibold text-sm truncate">{currentSong.title}</p>
                  <p className="text-gray-400 text-xs truncate">{currentSong.artist || t('music_unknown_artist')}</p>
                </div>
              </div>
              <button
                onClick={() => setShowLyrics(false)}
                className="p-2 text-gray-400 hover:text-white rounded-lg hover:bg-white/10 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Lyrics Font Size Controls + Info Button */}
            <div className="px-4 py-2 flex items-center justify-between" style={{ borderBottom: `1px solid ${theme.subtleBorder}` }}>
              <div className="flex items-center gap-2">
                <span className="text-gray-400 text-xs">{t('music_size')}</span>
                {[{key: 'small', label: 'music_small'}, {key: 'medium', label: 'music_medium'}, {key: 'large', label: 'music_large'}].map(size => (
                  <button
                    key={size.key}
                    onClick={() => setLyricsFontSize(size.key)}
                    className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${
                      lyricsFontSize === size.key
                        ? 'bg-purple-600 text-white'
                        : 'text-gray-400 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {t(size.label)}
                  </button>
                ))}
              </div>
              {/* Info/Description Button */}
              {currentSong?.description && (
                <button
                  onClick={() => setShowDescriptionPopup(true)}
                  className="flex items-center gap-1 px-3 py-1 rounded-lg text-xs font-medium bg-blue-600/20 text-blue-400 hover:bg-blue-600/30 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {t('music_info')}
                </button>
              )}
            </div>

            {/* Lyrics Content */}
            <div
              ref={lyricsContainerRef}
              className="flex-1 overflow-y-auto p-6"
            >
              {parsedLyrics.length > 0 ? (
                <div className="space-y-4">
                  {parsedLyrics.map((line, index) => (
                    <p
                      key={index}
                      className={`lyric-line transition-all duration-300 cursor-pointer hover:text-purple-300 ${
                        index === currentLyricIndex
                          ? `text-white font-bold ${lyricsFontClasses[lyricsFontSize].active}`
                          : index < currentLyricIndex
                            ? `text-gray-500 ${lyricsFontClasses[lyricsFontSize].inactive}`
                            : `text-gray-400 ${lyricsFontClasses[lyricsFontSize].inactive}`
                      }`}
                      onClick={() => {
                        if (line.time >= 0 && audioRef.current) {
                          audioRef.current.currentTime = line.time;
                          setCurrentTime(line.time);
                        }
                      }}
                    >
                      {line.text}
                    </p>
                  ))}
                </div>
              ) : (
                <div className="h-full flex flex-col items-center justify-center text-center relative overflow-hidden px-4">
                  {/* Expanding pulse rings */}
                  {isPlaying && (
                    <>
                      <div className="absolute rounded-full border-2 border-purple-500/40" style={{ width: 160, height: 160, animation: 'cd-ring-expand 2s ease-out infinite' }} />
                      <div className="absolute rounded-full border-2 border-pink-500/30" style={{ width: 160, height: 160, animation: 'cd-ring-expand 2s ease-out infinite 0.7s' }} />
                      <div className="absolute rounded-full border border-cyan-400/20" style={{ width: 160, height: 160, animation: 'cd-ring-expand 2s ease-out infinite 1.4s' }} />
                    </>
                  )}

                  {/* CD with float */}
                  <div className="relative" style={{ width: 150, height: 150, animation: isPlaying ? 'cd-float 3s ease-in-out infinite' : 'none' }}>
                    {/* Pulsing glow */}
                    {isPlaying && (
                      <>
                        <div className="absolute rounded-full blur-3xl" style={{ inset: -25, background: 'radial-gradient(circle, rgba(168,85,247,0.5) 0%, rgba(236,72,153,0.3) 40%, transparent 70%)', animation: 'cd-glow-pulse 2s ease-in-out infinite' }} />
                        <div className="absolute rounded-full blur-2xl" style={{ inset: -15, background: 'radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 60%)', animation: 'cd-glow-pulse 2.5s ease-in-out infinite 0.5s' }} />
                      </>
                    )}

                    {/* Orbiting light dots */}
                    {isPlaying && (
                      <>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-2.5 h-2.5 rounded-full bg-purple-400 blur-[2px]" style={{ animation: 'cd-flash-orbit 3s linear infinite', position: 'absolute', '--orbit-r': '92px' }} />
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-2 h-2 rounded-full bg-pink-400 blur-[2px]" style={{ animation: 'cd-flash-orbit2 4s linear infinite', position: 'absolute' }} />
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-1.5 h-1.5 rounded-full bg-cyan-400 blur-[1px]" style={{ animation: 'cd-flash-orbit 5s linear infinite reverse', position: 'absolute' }} />
                        </div>
                      </>
                    )}

                    {/* Sparkle dots */}
                    {isPlaying && [0,1,2,3,4,5].map(i => (
                      <div key={i} className="absolute w-1 h-1 rounded-full bg-white"
                        style={{
                          top: `${50 + 58 * Math.sin((i / 6) * Math.PI * 2)}%`,
                          left: `${50 + 58 * Math.cos((i / 6) * Math.PI * 2)}%`,
                          animation: `cd-sparkle ${1.5 + i * 0.3}s ease-in-out infinite ${i * 0.4}s`,
                        }} />
                    ))}

                    {/* CD disc */}
                    <div className="w-full h-full rounded-full relative overflow-hidden shadow-2xl"
                      style={{
                        animation: isPlaying ? 'cd-spin 3s linear infinite' : 'none',
                        background: 'conic-gradient(from 0deg, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e, #2d2d44, #1a1a2e)',
                        boxShadow: isPlaying ? '0 0 40px rgba(168,85,247,0.4), 0 0 80px rgba(236,72,153,0.2), 0 0 120px rgba(59,130,246,0.1)' : '0 8px 32px rgba(0,0,0,0.4)',
                      }}>
                      <div className="absolute inset-0 rounded-full"
                        style={{ background: 'conic-gradient(from 45deg, transparent 0%, rgba(255,255,255,0.06) 10%, transparent 20%, rgba(255,255,255,0.04) 30%, transparent 40%, rgba(255,255,255,0.08) 50%, transparent 60%, rgba(255,255,255,0.03) 70%, transparent 80%, rgba(255,255,255,0.05) 90%, transparent 100%)' }} />
                      <div className="absolute inset-[25%] rounded-full"
                        style={{ background: 'conic-gradient(from 0deg, rgba(168,85,247,0.15), rgba(59,130,246,0.15), rgba(16,185,129,0.15), rgba(245,158,11,0.15), rgba(236,72,153,0.15), rgba(168,85,247,0.15))', opacity: isPlaying ? 0.8 : 0.3 }} />
                      <div className="absolute inset-[15%] rounded-full border border-white/[0.03]" />
                      <div className="absolute inset-[20%] rounded-full border border-white/[0.03]" />
                      <div className="absolute inset-[30%] rounded-full border border-white/[0.02]" />
                      <div className="absolute inset-[35%] rounded-full border border-white/[0.03]" />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-purple-700 flex items-center justify-center"
                          style={{ boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.4)' }}>
                          <div className="w-3.5 h-3.5 rounded-full bg-gray-900" style={{ boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.6)' }} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="text-gray-200 text-base font-bold relative tracking-wide mt-6">{isPlaying ? `♪ ${t('music_feeling_beat')} ♪` : `🎵 ${t('music_no_lyrics')}`}</p>
                  <p className="text-gray-500 text-sm mt-1 relative">{isPlaying ? t('music_let_music_move') : t('music_press_play')}</p>
                </div>
              )}
            </div>

            {/* Current Playing Indicator */}
            {isPlaying && (
              <div className="p-4" style={{ borderTop: `1px solid ${theme.subtleBorder}`, background: theme.playingIndicatorBg }}>
                <div className="flex items-center gap-3">
                  <div className="flex gap-0.5">
                    <span className="w-1 h-4 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                    <span className="w-1 h-3 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                    <span className="w-1 h-5 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                    <span className="w-1 h-3 bg-pink-400 rounded-full animate-bounce" style={{ animationDelay: '450ms' }}></span>
                  </div>
                  <span className="text-white text-sm font-medium">{t('music_now_playing')}</span>
                  <span className="text-gray-400 text-xs ml-auto">{formatTime(currentTime)} / {formatTime(duration)}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Compact Centered Player - Desktop Only */}
      {currentSong && (
        <div className="hidden md:flex fixed bottom-4 left-1/2 -translate-x-1/2 z-50 justify-center" style={{ marginLeft: '128px' }}>
          <div className="rounded-full px-3 py-2 flex items-center gap-3" style={{ background: theme.playerBg, backdropFilter: 'blur(10px)', border: theme.playerBorder, boxShadow: theme.playerShadow }}>
            {/* Song Image */}
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0" style={{ background: theme.imagePlaceholderStrong, border: theme.imageBorder, boxShadow: theme.imageShadow }}>
              {currentSong.imageUrl ? (
                <img src={getDirectImageUrl(currentSong.imageUrl)} alt="" className="w-full h-full object-cover" draggable={false} />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-lg">🎵</span>
                </div>
              )}
            </div>

            {/* Song Info */}
            <div className="min-w-0 max-w-32">
              <p className="text-white font-medium text-xs truncate">{currentSong.title}</p>
              <p className="text-gray-400 text-[10px] truncate">{currentSong.artist || t('music_unknown_artist')}</p>
            </div>

            {/* Controls */}
            <div className="flex items-center gap-1">
              {/* Repeat */}
              <button
                onClick={() => setRepeatMode(repeatMode === 'none' ? 'all' : repeatMode === 'all' ? 'one' : 'none')}
                className={`p-1.5 transition-colors ${repeatMode !== 'none' ? 'text-purple-400' : 'text-gray-400 hover:text-white'}`}
                title={repeatMode === 'none' ? t('music_repeat_off') : repeatMode === 'all' ? t('music_repeat_all') : t('music_repeat_one')}
              >
                {repeatMode === 'one' ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"/>
                  </svg>
                ) : (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/>
                  </svg>
                )}
              </button>
              <button onClick={playPrevious} className="p-1.5 text-gray-400 hover:text-white transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 6h2v12H6V6zm3.5 6 8.5 6V6l-8.5 6z"/>
                </svg>
              </button>
              <button
                onClick={() => playSong(currentSong)}
                className="w-9 h-9 rounded-full flex items-center justify-center hover:scale-105 transition-transform"
                style={{ background: theme.accentBg, color: '#fff', boxShadow: theme.imageShadow }}
              >
                {isPlaying ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                  </svg>
                ) : (
                  <svg className="w-4 h-4 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7L8 5z"/>
                  </svg>
                )}
              </button>
              <button onClick={playNext} className="p-1.5 text-gray-400 hover:text-white transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
                </svg>
              </button>
            </div>

            {/* Progress mini bar - clickable */}
            <div className="w-28 h-1 rounded-full overflow-hidden cursor-pointer hover:h-2 transition-all" style={{ background: theme.progressTrack }} onClick={handleSeek}>
              <div
                className="h-full rounded-full"
                style={{ background: theme.progressFill, width: `${duration ? (currentTime / duration) * 100 : 0}%` }}
              />
            </div>

            {/* Time */}
            <span className="text-gray-400 text-[10px] w-16 text-center">{formatTime(currentTime)} / {formatTime(duration)}</span>

            {/* Volume */}
            <div className="flex items-center gap-1">
              <button
                onClick={() => {
                  if (volume > 0) {
                    previousVolumeRef.current = volume;
                    setVolume(0);
                    if (audioRef.current) audioRef.current.volume = 0;
                  } else {
                    const restored = previousVolumeRef.current || 0.7;
                    setVolume(restored);
                    if (audioRef.current) audioRef.current.volume = restored;
                  }
                }}
                className="p-1 text-gray-400 hover:text-white transition-colors"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {volume === 0 ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                  ) : volume < 0.5 ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M15.536 8.464a5 5 0 010 7.072" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M15.536 8.464a5 5 0 010 7.072 M18.364 5.636a9 9 0 010 12.728" />
                  )}
                </svg>
              </button>
              <input
                type="range"
                min="0" max="1" step="0.01"
                value={volume}
                onChange={handleVolumeChange}
                className="w-16 h-1 rounded-full appearance-none cursor-pointer"
                style={{ background: `linear-gradient(to right, ${theme.progressFill} ${volume * 100}%, ${theme.progressTrack} ${volume * 100}%)` }}
              />
            </div>

            {/* Close/Stop button */}
            <button
              onClick={() => { if (audioRef.current) { audioRef.current.pause(); } setCurrentSong(null); }}
              className="p-1.5 text-gray-400 hover:text-white transition-colors"
              title={t('music_stop')}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Mobile Mini Player Bar - Glassy compact design */}
      {currentSong && !showFullscreenPlayer && (
        <div className="md:hidden fixed bottom-20 left-4 right-4 z-40">
          <div className="rounded-full px-2 py-1.5 relative" style={{ background: theme.playerBg, backdropFilter: 'blur(10px)', border: theme.playerBorder, boxShadow: theme.playerShadow }}>
            {/* Left: Song Image + Title */}
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => setShowFullscreenPlayer(true)}>
              <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" style={{ background: theme.imagePlaceholderStrong, border: theme.imageBorder }}>
                {currentSong.imageUrl ? (
                  <img src={getDirectImageUrl(currentSong.imageUrl)} alt="" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <span className="text-xs">🎵</span>
                  </div>
                )}
              </div>
              <p className="text-white font-medium text-xs truncate max-w-[60px]">{currentSong.title}</p>
            </div>

            {/* Center: Controls - Absolutely centered */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-2">
              <button
                onClick={(e) => { e.stopPropagation(); playPrevious(); }}
                className="w-7 h-7 rounded-full bg-white/15 text-white flex items-center justify-center active:scale-95"
              >
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 6h2v12H6V6zm3.5 6 8.5 6V6l-8.5 6z"/>
                </svg>
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); playSong(currentSong); }}
                className="w-9 h-9 rounded-full text-white flex items-center justify-center active:scale-95"
                style={{ background: theme.accentBg, boxShadow: theme.imageShadow }}
              >
                {isPlaying ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                  </svg>
                ) : (
                  <svg className="w-4 h-4 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7L8 5z"/>
                  </svg>
                )}
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); playNext(); }}
                className="w-7 h-7 rounded-full bg-white/15 text-white flex items-center justify-center active:scale-95"
              >
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
                </svg>
              </button>
            </div>

            {/* Right: Close button */}
            <button
              onClick={(e) => { e.stopPropagation(); if (audioRef.current) { audioRef.current.pause(); } setCurrentSong(null); }}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white/10 text-gray-300 flex items-center justify-center active:scale-95"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* TikTok-Style Floating Menu - Right Side (Mobile Only) */}
      <div className="md:hidden fixed right-3 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-2">
        {/* Browse */}
        <button
          onClick={() => { setSidebarTab('browse'); setSelectedPlaylist(null); }}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-all shadow-md ${
            sidebarTab === 'browse' && !selectedPlaylist
              ? 'text-white'
              : 'text-gray-300'
          }`}
          style={sidebarTab === 'browse' && !selectedPlaylist ? { background: theme.floatingActiveBg, backdropFilter: 'blur(10px)' } : { background: theme.floatingInactiveBg, backdropFilter: 'blur(10px)' }}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </button>

        {/* Playlists Menu */}
        <button
          onClick={() => setShowMobilePlaylistMenu(true)}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-all shadow-md ${
            selectedPlaylist ? 'text-white' : 'text-gray-300'
          }`}
          style={selectedPlaylist ? { background: theme.floatingActiveBg, backdropFilter: 'blur(10px)' } : { background: theme.floatingInactiveBg, backdropFilter: 'blur(10px)' }}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
          </svg>
        </button>

        {/* Help — how to use Music */}
        <button
          onClick={() => setShowMusicHelp(true)}
          className="w-9 h-9 rounded-full flex items-center justify-center text-gray-300 transition-all shadow-md"
          style={{ background: theme.floatingInactiveBg, backdropFilter: 'blur(10px)' }}
          aria-label="How to use"
        >
          <span className="text-white font-extrabold text-lg leading-none">?</span>
        </button>
      </div>

      {/* Create Playlist Modal */}
      {showCreatePlaylist && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }} onClick={() => { setShowCreatePlaylist(false); setNewPlaylistName(''); }}>
          <div className="rounded-2xl p-5 md:p-6 w-full max-w-md" style={{ background: theme.modalBg, border: theme.modalBorder, boxShadow: theme.modalShadow }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-white text-lg md:text-xl font-bold">{t('music_create_playlist')}</h3>
              <button
                onClick={() => { setShowCreatePlaylist(false); setNewPlaylistName(''); }}
                className="p-2 rounded-full text-gray-400 hover:text-white transition-colors"
                style={{ background: theme.buttonSecondaryBg }}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <input
              type="text"
              placeholder={t('music_new_playlist_name')}
              value={newPlaylistName}
              onChange={(e) => setNewPlaylistName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && newPlaylistName.trim() && createPlaylist()}
              className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 mb-4"
              style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}` }}
              autoFocus
            />
            <div className="flex gap-3">
              <button
                onClick={() => { setShowCreatePlaylist(false); setNewPlaylistName(''); }}
                className="flex-1 px-4 py-3 text-white rounded-xl hover:opacity-80 transition-colors font-medium"
                style={{ background: theme.buttonSecondaryBg }}
              >
                {t('cancel')}
              </button>
              <button
                onClick={createPlaylist}
                disabled={!newPlaylistName.trim()}
                className="flex-1 px-4 py-3 text-white rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 font-medium"
                style={{ background: theme.accentBg }}
              >
                {t('music_create')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Playlist Confirmation Modal */}
      {deletePlaylistConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }}>
          <div className="rounded-2xl p-6 w-full max-w-md" style={{ background: theme.modalBg, border: '1px solid rgba(255,100,100,0.2)', boxShadow: theme.modalShadow }}>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
              <div>
                <h3 className="text-white text-xl font-bold">{t('music_delete_playlist')}</h3>
                <p className="text-gray-400 text-sm">{t('music_action_undone')}</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6">
              Are you sure you want to delete "<span className="text-white font-medium">{deletePlaylistConfirm.name}</span>"?
              This playlist has {deletePlaylistConfirm.songIds?.length || 0} songs.
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setDeletePlaylistConfirm(null)}
                className="flex-1 px-4 py-3 bg-gray-700 text-white rounded-xl hover:bg-gray-600 transition-colors font-medium"
              >
                {t('cancel')}
              </button>
              <button
                onClick={() => { deletePlaylist(deletePlaylistConfirm.id); setDeletePlaylistConfirm(null); }}
                className="flex-1 px-4 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors font-medium"
              >
                {t('music_delete')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mobile "How to use" help modal */}
      {showMusicHelp && (
        <div className="md:hidden fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }} onClick={() => setShowMusicHelp(false)}>
          <div className="w-full max-w-md rounded-2xl p-5 max-h-[80vh] overflow-y-auto" style={{ background: theme.modalBg, border: theme.modalBorder, boxShadow: theme.modalShadow }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-white text-lg font-bold">How to use Music</h3>
              <button
                onClick={() => setShowMusicHelp(false)}
                className="w-9 h-9 rounded-full flex items-center justify-center text-gray-300 hover:text-white"
                style={{ background: theme.buttonSecondaryBg }}
                aria-label="Close"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <ul className="space-y-3 text-sm text-gray-200">
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">1.</span><span>Tap any song to play it. Use the player at the bottom to pause, skip, or change songs.</span></li>
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">2.</span><span>Tap the <strong className="text-white">+</strong> on a song card to add it to a playlist (you can create a new one from the popup).</span></li>
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">3.</span><span>Tap the music-note icon on the right to open <strong className="text-white">My Playlists</strong>. Tap a playlist name to view its songs.</span></li>
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">4.</span><span>Inside a playlist, tap <strong className="text-white">←</strong> next to the title to go back to all songs.</span></li>
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">5.</span><span>Tap the <strong className="text-white">trash</strong> icon on a song card to remove it from the playlist.</span></li>
              <li className="flex gap-3"><span className="text-purple-400 font-bold flex-shrink-0">6.</span><span>Use the browse icon to see all songs and search by category.</span></li>
            </ul>
          </div>
        </div>
      )}

      {/* Mobile Playlist Menu */}
      {showMobilePlaylistMenu && (
        <div className="md:hidden fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }} onClick={() => setShowMobilePlaylistMenu(false)}>
          <div className="w-full max-w-md rounded-2xl p-5 max-h-[70vh] overflow-y-auto" style={{ background: theme.modalBg, border: theme.modalBorder, boxShadow: theme.modalShadow }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-white text-lg font-bold">{t('music_my_playlists')}</h3>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => { setShowMobilePlaylistMenu(false); setShowCreatePlaylist(true); }}
                  className="px-3 py-1.5 rounded-lg text-sm font-medium text-white"
                  style={{ background: theme.accentBg }}
                >
                  {t('music_new')}
                </button>
                <button
                  onClick={() => setShowMobilePlaylistMenu(false)}
                  className="w-9 h-9 rounded-full flex items-center justify-center text-gray-300 hover:text-white"
                  style={{ background: theme.buttonSecondaryBg }}
                  aria-label="Close"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            {/* Hint: how to view a playlist */}
            <p className="text-xs text-gray-400 mb-3">Tap a playlist name to see its songs.</p>
            {userPlaylists.length === 0 ? (
              <p className="text-gray-400 text-center py-6">{t('music_no_playlists')}</p>
            ) : (
              <div className="space-y-2">
                {userPlaylists.map(playlist => (
                  <div key={playlist.id} className={`rounded-xl p-3 ${selectedPlaylist?.id === playlist.id ? '' : ''}`}
                    style={{ background: selectedPlaylist?.id === playlist.id ? theme.playlistSelectedBg : theme.playlistItemBg, border: `1px solid ${theme.subtleBorder}` }}>
                    {editingPlaylist === playlist.id ? (
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={editPlaylistName}
                          onChange={(e) => setEditPlaylistName(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && renamePlaylist(playlist.id, editPlaylistName)}
                          className="flex-1 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
                          autoFocus
                        />
                        <button onClick={() => renamePlaylist(playlist.id, editPlaylistName)} className="p-2 text-green-400">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                        </button>
                        <button onClick={() => { setEditingPlaylist(null); setEditPlaylistName(''); }} className="p-2 text-red-400">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => { setSelectedPlaylist(playlist); setSidebarTab('browse'); setShowMobilePlaylistMenu(false); }}
                          className="flex-1 text-left"
                        >
                          <p className={`font-medium text-sm ${selectedPlaylist?.id === playlist.id ? 'text-purple-300' : 'text-white'}`}>{playlist.name}</p>
                          <p className="text-gray-400 text-xs">{playlist.songIds?.length || 0} {t('music_songs')}</p>
                        </button>
                        <button onClick={() => { playAllInPlaylist(playlist); setShowMobilePlaylistMenu(false); }} className="p-2 text-green-400">
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7L8 5z"/></svg>
                        </button>
                        <button onClick={() => { setEditingPlaylist(playlist.id); setEditPlaylistName(playlist.name); }} className="p-2 text-blue-400">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
                        </button>
                        <button onClick={() => { setShowMobilePlaylistMenu(false); setDeletePlaylistConfirm(playlist); }} className="p-2 text-red-400">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Add to Playlist Modal */}
      {showAddToPlaylist && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
          <div className="rounded-2xl p-6 w-full max-w-md" style={{ background: theme.modalBg, border: theme.modalBorder, boxShadow: theme.modalShadow }}>
            <h3 className="text-white text-xl font-bold mb-4">{t('music_add_to_playlist')}</h3>
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {userPlaylists.length === 0 ? (
                <p className="text-gray-400 text-center py-4">{t('music_no_playlists_first')}</p>
              ) : (
                userPlaylists.map(playlist => (
                  <button
                    key={playlist.id}
                    onClick={() => addToPlaylist(playlist.id, showAddToPlaylist)}
                    className="w-full flex items-center justify-between px-4 py-3 rounded-xl transition-colors text-left"
                    style={{ background: theme.buttonSecondaryBg }}
                  >
                    <span className="text-white">{playlist.name}</span>
                    <span className="text-gray-400 text-sm">{playlist.songIds?.length || 0} {t('music_songs')}</span>
                  </button>
                ))
              )}
            </div>
            <button
              onClick={() => setShowAddToPlaylist(null)}
              className="w-full mt-4 px-4 py-2 text-white rounded-xl transition-colors"
              style={{ background: theme.buttonSecondaryBg }}
            >
              {t('cancel')}
            </button>
          </div>
        </div>
      )}

      {/* Song Description Popup */}
      {showDescriptionPopup && currentSong && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setShowDescriptionPopup(false)}>
          <div className="rounded-2xl p-6 w-full max-w-md shadow-2xl" style={{ background: theme.modalBg, border: theme.modalBorder, boxShadow: theme.modalShadow }} onClick={e => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 rounded-xl overflow-hidden bg-gradient-to-br from-purple-600 to-pink-600 flex-shrink-0">
                {currentSong.imageUrl ? (
                  <img src={getDirectImageUrl(currentSong.imageUrl)} alt="" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <span className="text-2xl">🎵</span>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-white text-lg font-bold truncate">{currentSong.title}</h3>
                <p className="text-gray-400 text-sm truncate">{currentSong.artist || t('music_unknown_artist')}</p>
              </div>
              <button
                onClick={() => setShowDescriptionPopup(false)}
                className="p-2 rounded-full bg-white/10 text-gray-400 hover:text-white hover:bg-white/20 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Description Content */}
            <div className="bg-white/5 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-blue-400 font-medium text-sm">{t('music_about_song')}</span>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed whitespace-pre-wrap">
                {currentSong.description || t('music_no_description')}
              </p>
            </div>

            {/* Category Badge */}
            {currentSong.category && (
              <div className="mt-4 flex items-center gap-2">
                <span className="text-gray-500 text-xs">{t('music_category')}</span>
                <span className="px-3 py-1 rounded-full bg-purple-600/20 text-purple-300 text-xs font-medium">
                  {categories.find(c => c.id === currentSong.category)?.name || 'Unknown'}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {showProGlass && (
        <>
          <div className="absolute inset-0 z-20 cursor-not-allowed"
               style={{ backdropFilter: 'blur(2px)', WebkitBackdropFilter: 'blur(2px)',
                        backgroundColor: isDarkMode ? 'rgba(17,24,39,0.06)' : 'rgba(255,255,255,0.06)' }} />
          <div className="fixed z-30 pointer-events-none px-4" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'min(90vw, 28rem)' }}>
            <div className={`pointer-events-auto text-center p-5 sm:p-8 rounded-3xl shadow-2xl ring-4 ring-white/30 ${isDarkMode ? 'bg-gray-900/95' : 'bg-white/95'}`}>
              <span className="text-4xl sm:text-6xl mb-2 sm:mb-4 block">🎵</span>
              <h2 className={`text-xl sm:text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Music</h2>
              <p className={`text-sm sm:text-base mb-4 sm:mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Pro feature. Unlock Darija songs with synced lyrics, playlists, and learning tools.
              </p>
              <button
                onClick={() => { if (setInitialProfileTab) setInitialProfileTab('membership'); if (setCurrentView) setCurrentView('profile'); }}
                className="px-5 sm:px-6 py-2.5 sm:py-3 rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold shadow-2xl hover:scale-105 transition-all flex items-center gap-2 mx-auto cursor-pointer">
                <span className="text-lg sm:text-xl">🔓</span><span>Upgrade to Pro</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};




export default MusicPage;
